import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const formstack = defineConnector({
  identifier: "formstack",
  name: "Formstack",
  tagLine: "Online form builder",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://www\\.formstack\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Formstack](https://www.formstack.com/), go to your account and navigate to **API** to generate an access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.formstack.com/api/v2/form.json",
  },
});
